import { combineReducers } from 'redux';
import alert from './alert';
import auth from './auth';
import eventlog from './eventlog';
import cotation from './cotation';
import user from './user';

export default combineReducers({
  alert,
  auth,
  eventlog,
  user,
  cotation
});
